import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const orderBillNoSyncs = createAction(Constants.ORDER_SYNC_BILL_NO.REQUEST);

export const fetchOrdersBillNo = createAction(Constants.ORDER_LIST_BILL_NO.REQUEST);
